'use strict';

Number.isInteger = Number.isInteger || function (value) {
  return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-ratings-declarative/build/ie-isInteger-polyfill.js
// module id = 131
// module chunks = 0